import React from 'react';
import '../../../node_modules/tiny-date-picker/tiny-date-picker.css';

export default function (props){
	const { propertyName, className, minDate, placeholder, onChange, selectedValue } = props;
	return (
		<input name={propertyName} className={className} type="date" value={selectedValue} required min={minDate} placeholder={placeholder} onChange={(e) => onChange(e)} />
	);
}


// WEBPACK FOOTER //
// ./src/components/dateSelector/DateSelectorView.js